/**
 * Source-backed pedestrian hand-off between Vilnius Bus Station and Vilnius
 * Railway Station. Coordinates are transformed from the cited OSM ways into
 * the project's documented EPSG:3346 local origin. The authored signs clarify
 * the route; the separately rendered OSM/GRPK paths remain the ground truth.
 */
export const VILNIUS_STATION_INTERCHANGE = Object.freeze({
  capturedAt: "2026-08-07T15:36:11Z",
  sourceLayer: "openstreetmap-footways-separable-odbl",
  license: "ODbL-1.0",
  copyrightUrl: "https://www.openstreetmap.org/copyright",
  points: Object.freeze([
    Object.freeze({
      id: "bus-side-wayfinding",
      osmWayId: 443195103,
      sourceKind: "paved-sidewalk",
      world: Object.freeze({ x: 292.9, y: 60.88, z: 1938.347 }),
      yawRadians: -0.37,
      labels: Object.freeze(["GELEŽINKELIO STOTIS", "RAILWAY STATION"]),
    }),
    Object.freeze({
      id: "marked-crossing",
      osmWayId: 949743081,
      sourceKind: "marked-crossing",
      world: Object.freeze({ x: 345.818, y: 63.52, z: 1995.491 }),
      yawRadians: 0.59,
      labels: Object.freeze(["AUTOBUSŲ STOTIS", "GELEŽINKELIO STOTIS"]),
    }),
    Object.freeze({
      id: "rail-side-wayfinding",
      osmWayId: 439924546,
      sourceKind: "lit-sidewalk",
      world: Object.freeze({ x: 466.02, y: 65.1, z: 1973.278 }),
      yawRadians: 1.12,
      labels: Object.freeze(["AUTOBUSŲ STOTIS", "BUS STATION"]),
    }),
  ]),
});
